export default import.meta.ROLLUP_FILE_URL_Ngmgj7KrmSrUoXH_NFNtFA;